<script lang="ts" setup>
import { useNavButton } from './composables/useNavButton'

const { locale } = useI18n()
const lang = computed(() => locale.value)
useNavButton()
</script>

<template>
  <Html :lang="lang">
    <Body>
      <UiNavigation :sticking="false" />
      
      <main class="main">
        <slot />
      </main>

      <UiFooter />
    </Body>
  </Html>
</template>
